module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"locale","generateDefaultLanguagePage":true,"languages":["en","pt","es","fr","nl","de","it","tr","ru","zh-CN","zh-TW"],"redirect":false,"i18nextOptions":{"interpolation":{"escapeValue":false}}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
